<template>
    <div class="buttons">
        <h1>Buttons</h1>
        <div>
            <button>Button</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'buttons'
    }
</script>



// WEBPACK FOOTER //
// src/components/previews/Buttons.vue